import { AbstractLocaleMessageObject } from "@/i18n/AbstractLocaleMessageObject"

export class LoginInputJa extends AbstractLocaleMessageObject {
  readonly inputLabelCompanyId: string = "加盟店ID"

  readonly inputTextBoxCompanyIdPlaceholder: string = "英数字50文字以内で入力してください"

  readonly inputLabelMailAddress: string = "メールアドレス"

  readonly inputTextBoxMailAddressPlaceholder: string = "メールアドレスを入力してください"

  readonly inputLabelPassword: string = "パスワード"

  readonly inputTextBoxPasswordPlaceholder: string = "英数記号で入力してください"

  readonly operationButtonForgotPassword: string = "パスワードを忘れた方はこちら"

  readonly operationButtonLogin: string = "ログイン"

  readonly error903: string = "加盟店ID・メールアドレス・パスワードに誤りがあるか、登録されていません。"

  readonly error913: string = "再度ログインしてください"
}
